import React from 'react';

export default function SVGCloseX(): JSX.Element {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7241 0.0478516L8.72265 6.04785L2.72265 0.0478516L0.722656 2.04785L6.72265 8.04785L0.722656 14.0479L2.72265 16.0479L8.72265 10.0479L14.7241 16.0479L16.7241 14.0479L10.7241 8.04785L16.7241 2.04785L14.7241 0.0478516Z"
        fill="#666666"
      />
    </svg>
  );
}
